import {
    Order
  } from '../../../../../core';
  import moment from 'moment';
  import { DataTable, IconsOfActions } from '../../data-table.interface';
  const iconsOfActionsList: IconsOfActions[] = [
  {
    icon: 'locate-dispatches',
    tooltip: 'Ubicar'
  }
  ];
  export const returnManagement: DataTable = {
    searchText: '',
    addText: '',
    export: true,
    exportFile: 'Retiro en tienda.xlsx',
    expandable: true,
    filter: false,
    paginator: true,
    filterDefault: '',
    disabled: false,
    partialField: '',
    checkbox: true,
    checkboxHeader: false,
    iconsOfActions: iconsOfActionsList,
    hasDisabledCheckBoxItem: (item:Order)=>{
      return !item.isUbication || item.itemDisabled
    },
    columns: [
      {
        title: 'N° de NV',
        name: 'orderNumber',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left w130',
        value: (element: Order) => element.orderNumber
      },
      {
        title: 'N° de Despacho',
        name: 'dispatchNumber',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Order) => element.dispatchNumber
      },
      {
        title: 'Cliente',
        name: 'customer',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Order) => element.customer
      }, 
      {
        title: 'Entidad de Venta',
        name: 'saleEntity',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Order) => element.entity
      },
      {
        title: 'Origen',
        name: 'originEntity',
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Order) => element.entity
      },
      {
        title: 'Última Entidad',
        name: 'deliveryEntity', //entity
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left',
        value: (element: Order) => element.entity
      },
      {
        title: 'Fecha de entrega', //retiro
        name: 'deliveryDate', //retireDate
        type: 'string',
        editable: false,
        checkAll: false,
        class: 'left w120',
        value: (element: Order) => element.retireDate ? moment(element.retireDate).format('YYYY-MM-DD') : '---'
      },
      {
        title: 'Imagen',
        type: 'button',
        name: 'image',
        editable: false,
        checkAll: false,
        class: 'left',
        value: () => {
          return {
            icon: 'photo',
            svg: true,
            tooltip: 'Ver detalles del producto',
            class: 'recordColumn icon-table'
          };
        }
      }
    ],
    subTable: {}
  };
  